import { ApplicationState } from 'application/redux';
import { close as closeModal, open as openModal } from 'core/modal/redux/actions';
import { executeCommand } from 'core/utils/deviceUtils';
import { connect } from 'react-redux';
import { changeParentalPin, clearFields, runCommands, setParentalPinError } from '../redux/actions';
import ConfigurationsComponent from './configurations-component';

const mapStateToProps = (state: ApplicationState) => ({
  t: state.i18n.t,
  settings: state.devices.detail._settings,
  general: state.devices.detail.general,
});

export default connect(mapStateToProps, {
  clearFields,
  openModal,
  closeModal,
  runCommands,
  changeParentalPin,
  setParentalPinError,
  executeCommand,
})(ConfigurationsComponent);
